module.exports = __webpack_public_path__ + "static/img/NickKyrgios.54e89af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NickKyrgios.jpg
// module id = Uh67
// module chunks = 0